/* eslint-disable no-underscore-dangle */
/* eslint-disable import/no-extraneous-dependencies */
import React, { useEffect, useState } from 'react';
import { Formik, Field, Form } from 'formik';
import PropTypes from 'prop-types';
import { useNavigate } from 'react-router-dom';
import {
  Button,
  Box,
  CircularProgress,
  Grid,
  Card,
  CardContent,
  CardHeader,
  CardActions,
  FormHelperText,
  // IconButton,
  // InputAdornment,
  TextField,
  Autocomplete,
  Checkbox,
  FormControlLabel
} from '@mui/material';
import { useDispatch, useSelector } from 'react-redux';
import { CardElement, useStripe, useElements } from '@stripe/react-stripe-js';
import PaymentAction from '../../../store/actions/PaymentAction';
import PaymentLoader from '../../../utils/errorPages/PaymentLoader';
import globalAction from '../../../store/actions/GlobalAction';
import CardImage from '../../../assets/images/card.png';
import { ValidateStripeCard } from '../../../assets/validation';

function PaymentStripeForm({ clientinfo, code }) {
  const [paymentIntentId, setPaymentIntentId] = useState('');
  const [cardError, setCardError] = useState('');
  const [clientSecretID, setClientSecretID] = useState('');
  const navigate = useNavigate();
  const [checked, setChecked] = React.useState(false);

  const handleSameAddress = (event, setFieldValue) => {
    if (event.target.checked) {
      setChecked(true);
      // Use clientinfo for address fields
      setFieldValue('holder_name', clientinfo?.name || '');
      setFieldValue('address_1', clientinfo?.address_1 || '');
      setFieldValue('address_2', clientinfo?.address_2 || '');
      setFieldValue('city', clientinfo?.city || '');
      setFieldValue('zip_code', clientinfo?.postal_code || '');
      setFieldValue('country', clientinfo?.country || '');
      setFieldValue('state', clientinfo?.state || '');
      // Add more fields if needed
    } else {
      setChecked(false);
      // Clear address fields
      setFieldValue('holder_name', '');
      setFieldValue('address_1', '');
      setFieldValue('address_2', '');
      setFieldValue('city', '');
      setFieldValue('zip_code', '');
      setFieldValue('country', '');
      setFieldValue('state', '');
      // Clear more fields if needed
    }
  };
  const { countryData, stateData, isLoading } = useSelector((state) => state.global);
  const dispatch = useDispatch();
  useEffect(() => {
    dispatch(globalAction.getCountryStatus());
  }, [dispatch]);

  const handleCountryChange = (countryId) => {
    dispatch(globalAction.getStateStatus(countryId));
  };

  const stripe = useStripe();
  const elements = useElements();

  const confirmPaymentStripe = async (clientSecret, setSubmitting) => {
    if (clientSecret !== '') {
      setCardError('');
      const { paymentIntent, error } = await stripe.confirmCardPayment(clientSecret, {
        payment_method: {
          card: elements.getElement(CardElement)
        }
      });

      if (error) {
        // Handle Stripe.js errors (display to user)
        setSubmitting(false);
        setCardError(error.message);
        return;
      }

      const intentId = paymentIntent.id;
      setPaymentIntentId(intentId);

      const formData = {
        intent_id: intentId
      };

      setTimeout(() => {
        // Payment confirmed, submit the form to capture payment on the server-side
        dispatch(PaymentAction.updateStripeCapture(code, formData, navigate, setSubmitting));
      }, 1000);
    }
  };

  const handleSubmit = (values, { setErrors, setSubmitting }) => {
    if (!stripe || !elements) {
      // Stripe.js has not loaded yet. Make sure to disable form submission until Stripe.js has loaded.
      return;
    }

    const { ...newValuesWithoutExpire } = values;
    const newValues = {
      ...newValuesWithoutExpire,
      country: values.country.name,
      state: values.state.name
    };

    if (clientSecretID) {
      confirmPaymentStripe(clientSecretID, setSubmitting);
    } else {
      dispatch(
        PaymentAction.updateStripe(
          code,
          newValues,
          setErrors,
          setSubmitting,
          setClientSecretID,
          confirmPaymentStripe
        )
      );
    }

    // // Create a payment intent
    // const createIntentResponse = await fetch('/payment/create', {
    //   method: 'POST',
    //   headers: {
    //     'Content-Type': 'application/json',
    //     Accept: 'application/json'
    //   },
    //   body: JSON.stringify({
    //     holder_name: 'test',
    //     address_1: 'test address1',
    //     address_2: 'test address2',
    //     city: 'Austin',
    //     state: 'AU',
    //     zip_code: '12345',
    //     country: 'United states'
    //   })
    // });

    // Confirm the payment intent
  };

  console.log(paymentIntentId, 'paymentIntentId');

  return (
    <Box sx={{ mb: 3 }} className="cardWrapper requestType">
      <Formik
        initialValues={{
          holder_name: '',
          address_1: '',
          address_2: '',
          country: '',
          state: '',
          city: '',
          zip_code: ''
        }}
        enableReinitialize
        validationSchema={ValidateStripeCard}
        onSubmit={handleSubmit}
      >
        {({
          errors,
          touched,
          values,
          handleChange,
          handleBlur,
          // handleReset,
          isSubmitting,
          setFieldValue
        }) => (
          <Form id="paymentForm">
            {isSubmitting ? <PaymentLoader /> : ''}
            <Grid container columnSpacing={2} rowSpacing={0} alignItems="stretch">
              <Grid item lg={6} xl={6}>
                <Card sx={{ mt: 2 }}>
                  <CardHeader
                    sx={{ textAlign: 'left !important' }}
                    title="Credit Card Details"
                    action={<img src={CardImage} alt="Credit Card" />}
                  />
                  <CardContent>
                    <div id="card-element" className="card-element-container">
                      <CardElement
                        options={{
                          style: {
                            base: {
                              fontSize: '16px',
                              color: '#32325d',
                              fontFamily: 'Arial, sans-serif'
                            },
                            invalid: {
                              color: '#fa755a'
                            }
                          }
                        }}
                      />
                    </div>
                    <input type="hidden" name="intent_id" value={paymentIntentId} />
                  </CardContent>
                </Card>
                {cardError && <FormHelperText error>{cardError}</FormHelperText>}
              </Grid>
              <Grid item lg={6} xl={6}>
                <Card sx={{ mt: 2 }}>
                  <CardHeader
                    sx={{ textAlign: 'left !important' }}
                    title="Cardholder Address"
                    action={
                      <FormControlLabel
                        label="Same as Client Address"
                        control={
                          <Checkbox
                            checked={checked}
                            onChange={(event) => {
                              handleSameAddress(event, setFieldValue);
                            }}
                            inputProps={{ 'aria-label': 'controlled' }}
                          />
                        }
                      />
                    }
                  />
                  <CardContent>
                    <Grid container columnSpacing={2} rowSpacing={0} alignItems="stretch">
                      <Grid item lg={12} xl={12}>
                        <Field name="holder_name">
                          {({ field }) => (
                            <TextField
                              {...field}
                              label="Cardholder Name"
                              fullWidth
                              margin="normal"
                              variant="outlined"
                              required={false}
                              InputLabelProps={{ required: true }}
                              onChange={(event) => {
                                field.onChange(event);
                              }}
                              error={touched.holder_name && Boolean(errors.holder_name)}
                              helperText={touched.holder_name && errors.holder_name}
                            />
                          )}
                        </Field>
                      </Grid>
                      <Grid item lg={6} xl={6}>
                        <TextField
                          error={errors.address_1 && touched.address_1}
                          label="Address Line 1"
                          className=""
                          fullWidth
                          name="address_1"
                          value={values.address_1}
                          // maxRows={4}
                          placeholder="Enter Address Line 1"
                          onChange={handleChange}
                          onBlur={handleBlur}
                          helperText={errors.address_1 && touched.address_1 && errors.address_1}
                          margin="normal"
                          variant="outlined"
                          required={false}
                          InputLabelProps={{ required: true }}
                        />
                      </Grid>
                      <Grid item lg={6} xl={6}>
                        <TextField
                          error={errors.address_2 && touched.address_2}
                          label="Address Line 2"
                          className=""
                          fullWidth
                          name="address_2"
                          // maxRows={4}
                          placeholder="Enter Address Line 1"
                          onChange={handleChange}
                          onBlur={handleBlur}
                          helperText={errors.address_2 && touched.address_2 && errors.address_2}
                          margin="normal"
                          variant="outlined"
                          // required={false}
                          // InputLabelProps={{ required: true }}
                        />
                      </Grid>
                    </Grid>
                    <Grid container columnSpacing={2} rowSpacing={0} alignItems="stretch">
                      <Grid item lg={6} xl={6}>
                        <Field
                          name="country"
                          component={Autocomplete}
                          className="CurrencyField"
                          options={countryData ?? []}
                          // disableClearable
                          onChange={(e, newvalue) => {
                            setFieldValue('country', newvalue);
                            if (newvalue && newvalue._id) {
                              handleCountryChange(newvalue._id);
                            }
                          }}
                          loading={isLoading}
                          value={values.country}
                          getOptionLabel={(option) => (option ? option.name : '')}
                          isOptionEqualToValue={(option, value) => option.name === value.name}
                          renderOption={(props, option) => {
                            return (
                              <li {...props} key={option._id}>
                                {option.name}
                              </li>
                            );
                          }}
                          renderInput={(params) => (
                            <TextField
                              {...params}
                              name="country"
                              error={touched.country && !!errors.country}
                              helperText={touched.country && errors.country}
                              label="Select Country"
                              placeholder="Search Country"
                              variant="outlined"
                              margin="normal"
                              required={false}
                              InputLabelProps={{ required: true }}
                              // SelectProps={{
                              //   IconComponent: ExpandMore
                              // }}
                            />
                          )}
                        />
                      </Grid>
                      <Grid item lg={6} xl={6}>
                        <Field
                          name="state"
                          component={Autocomplete}
                          className="CurrencyField"
                          isOptionEqualToValue={(option, value) => option.name === value.name}
                          value={values.state}
                          options={stateData ?? []}
                          // disableClearable
                          onChange={(e, newvalue) => {
                            setFieldValue('state', newvalue);
                          }}
                          loading={isLoading}
                          getOptionLabel={(option) => (option ? option.name : '')}
                          renderOption={(props, option) => {
                            return (
                              <li {...props} key={option._id}>
                                {option.name}
                              </li>
                            );
                          }}
                          renderInput={(params) => (
                            <TextField
                              {...params}
                              name="state"
                              error={touched.state && !!errors.state}
                              helperText={touched.state && errors.state}
                              label="Select State"
                              placeholder="Search State"
                              variant="outlined"
                              margin="normal"
                              required={false}
                              InputLabelProps={{ required: true }}
                              // SelectProps={{
                              //   IconComponent: ExpandMore
                              // }}
                            />
                          )}
                        />
                      </Grid>
                    </Grid>
                    <Grid container columnSpacing={2} rowSpacing={0} alignItems="stretch">
                      <Grid item lg={6} xl={6}>
                        <TextField
                          error={errors.city && touched.city}
                          label="City"
                          className=""
                          fullWidth
                          name="city"
                          value={values.city}
                          // maxRows={4}
                          placeholder="Enter City"
                          onChange={handleChange}
                          onBlur={handleBlur}
                          helperText={errors.city && touched.city && errors.city}
                          margin="normal"
                          variant="outlined"
                          required={false}
                          InputLabelProps={{ required: true }}
                        />
                      </Grid>
                      <Grid item lg={6} xl={6}>
                        <Box className="datepicker">
                          <TextField
                            error={errors.zip_code && touched.zip_code}
                            label="Postal Code"
                            className=""
                            fullWidth
                            name="zip_code"
                            value={values.zip_code}
                            // maxRows={4}
                            placeholder="Enter Postal Code"
                            onChange={handleChange}
                            onBlur={handleBlur}
                            helperText={errors.zip_code && touched.zip_code && errors.zip_code}
                            margin="normal"
                            variant="outlined"
                            required={false}
                            InputLabelProps={{ required: true }}
                          />
                        </Box>
                      </Grid>
                    </Grid>
                  </CardContent>
                </Card>
              </Grid>
            </Grid>
            <Card sx={{ mt: 2 }}>
              <CardActions sx={{ justifyContent: 'center', py: '20px!important' }}>
                <Button
                  type="submit"
                  className="save__btn"
                  variant="contained"
                  color="secondary"
                  // fullWidth
                  disabled={isSubmitting}
                  size="large"
                >
                  {isSubmitting ? <CircularProgress size={20} /> : 'Submit'}
                </Button>
              </CardActions>
            </Card>
          </Form>
        )}
      </Formik>
    </Box>
    // <form onSubmit={handleSubmit} id="paymentForm">
    //   <div id="card-element" className="card-element-container">
    //
    //   <button type="submit">Pay Now</button>
    // </form>
  );
}

PaymentStripeForm.propTypes = {
  code: PropTypes.string.isRequired,
  clientinfo: PropTypes.func.isRequired
};

export default PaymentStripeForm;
